import * as types from '../actiontypes';
import {serviceURL} from '../../util/uiconstants';
import env from '../../util/env';
import { API_RESOURCES, createApiReadAction } from '../../util/api';

export const createForm = (engagementId, data) => {
	let url = env.getBaseURL(serviceURL, Number(engagementId)) + 'Forms';

	return {
		type: types.POST_FORM,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
};

export function getFormActions(engagementId, formCategory, filterDocumentIds, includeAvailableActions, includeSelectedActions, includeRelatedRisks, queryParameters, actionProps) {

	let _filterDocumentIds;
	if (filterDocumentIds) {
		_filterDocumentIds = Array.isArray(filterDocumentIds) ? filterDocumentIds : [filterDocumentIds];
	}

	const queryParams = {
		formCategory: formCategory,
		filterDocumentIds: _filterDocumentIds?.join(',') || [],
		includeAvailableActions,
		includeSelectedActions,
		includeRelatedRisks,
		...queryParameters
	};

	return createApiReadAction(
		types.GET_ENGAGEMENT_FORM_ACTIONS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FORMACTIONS]: undefined
		},
		queryParams,
		{resolve: true, ...actionProps}
	);
}